/**
 * StringUtil.js
 * Created on 7-okt-2015
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/

/**
 * Replaces all occurence of keys in Object variables with values.
 * Occurences of keys are delimited (default by '%' chars).
 * Example:
 * input: "Hello, my name is %NAME% %SURNAME%."
 * variables: {name:"Hank", surname:"Williams"}
 * return value: "Hello, my name is Hank Williams."
 * @param	input The input string.
 * @param	variables The key/value pairs to be replaced
 * @return
 */
 export function resolveVariablesInString (input, variables) {
    var openChar = "%", closeChar = "%";
    var res = input;
    for (var s in variables) {
        res = res.split(openChar + s + closeChar).join(variables[s]);
    }
    return res;
}

export function capitalize (str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
}

/**
 * Method checks if email address is syntactically valid.
 * From Senocular: http://www.kirupa.com/forum/showthread.php?p=1914673
 * @param	email Email address to validate.
 * @return Boolean indication validity of email address
 */
export function isValidEmail (email) {
    var emailExpression = /^[a-z][\w.-]+@\w[\w.-]+\.[\w.-]*[a-z][a-z]$/i;
    return emailExpression.test(email);
}

/**
 * Trims all leading and trailing whitespace
 * @param	str Input string
 * @return String without leading and trailing whitespace
 */
export function trim (str) {
    return str.replace(/^\s+|\s+$/g, "");
}

/**
 * Truncates the string and adds a suffix
 * @param	str Input string
 * @param	length Max length of the string
 * @param	suffix Optional suffix to place at the on of the truncated string, defaults to an ellipsis
 * @return Truncated string with a suffix if the length of the string is longer than the given length
 */
export function truncate (str, length, suffix) {
    suffix = suffix === undefined ? "..." : suffix;
    if (str.length > length) {
        return str.substring(0, length) + suffix;
    }
    return str;
}

/**
 * Adds padding to the left of a string
 * @param	str Input string
 * @param	pad Padding (e.g. '0')
 * @param	length Max string length, overflow will be cut off from the right
 * @return  string with provided padding and truncated to match given length
 */
export function padLeft (str, pad, length) {
    return (new Array(length + 1).join(pad) + str).slice(-length);
}

/**
 * Transforms camel-case string into capitalized, space-separated string.
 * E.g.: "thisCamelCase" => "This Camel Case"
 * @param {String} str 
 * @returns {String}
 */
export function camelCaseToSpaces (str) {
    return str
        // insert a space before all caps
        .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, function(str) { return str.toUpperCase(); })
}

/**
 * Determines if the given string has Chinese, Japanese, or Korean (CJK) characters
 * @param {string} str 
 * @returns {boolean} True if it has CJK characters; False, otherwise.
 */
export function containsCJKCharacters(str) {
    return containsChineseCharacters(str) || containsJapaneseCharacters(str) || containsHangulCharacters(str);
}

/**
 * Determines if the given string has Chinese characters
 * @param {string} str 
 * @returns {boolean} True if it has Chinese characters; False, otherwise
 */
export function containsChineseCharacters(str) {
    // based from https://web.archive.org/web/20210623131250/https://flyingsky.github.io/2018/01/26/javascript-detect-chinese-japanese/
    const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
    return REGEX_CHINESE.test(str);
}

/**
 * Determines if the given string has Japanese characters
 * @param {strings} str 
 * @returns {boolean} True if it has Japanese characters; False, otherwise
 */
export function containsJapaneseCharacters(str) {
    // based from https://web.archive.org/web/20210623131250/https://flyingsky.github.io/2018/01/26/javascript-detect-chinese-japanese/
    // NB: the original source used \uff00-\uff9f (the full "Halfwidth and Fullwidth Forms" Unicode block), but
    // U+FF00-U+FF60 are fullwidth ASCII variants (（, ）, ！, Ａ, etc.) — not Japanese script. Only U+FF61-U+FF9F
    // are halfwidth katakana and should trigger the CJK path.
    const REGEX_JAPANESE = /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff61-\uff9f]|[\u4e00-\u9faf]|[\u3400-\u4dbf]/;
    // NB: Japanese is composed by Kanji and Hiragana (chinese) characters
    return REGEX_JAPANESE.test(str) || containsChineseCharacters(str);
}

/**
 * Determins if the given string has Hangul (Korean) characters
 * @param {string} str 
 * @returns {boolean} True if it has Korean characters; False, otherwise
 */
export function containsHangulCharacters(str) {
    // based from https://web.archive.org/web/20210623131340/https://stackoverflow.com/questions/52989330/what-is-proper-way-to-test-if-the-input-is-korean-or-chinese-using-javascript/52989471
    const REGEX_HANGUL = /[\uac00-\ud7af]|[\u1100-\u11ff]|[\u3130-\u318f]|[\ua960-\ua97f]|[\ud7b0-\ud7ff]/;
    return REGEX_HANGUL.test(str);
}